export const SIGNIN = (state, data) => {
  state.user = data.data
  state.loggedIn = true
}

export const SIGNOUT = state => {
  state.user = {}
  state.loggedIn = false
}

export const updateUser = (state, val) => {
  state.user = val
  state.loggedIn = true
  let role = val.role
  let permissions = []

  role.permissions.forEach(perm => {
    permissions.push(perm.name)
  })

  state.permissions = permissions
}

export const FCM_TOKEN = (state, val) => {
  state.fcm_token = val
}
